import {
    banking___gem,
    communication_feedback_agreement,
    interaction___flashOn,
    object___clock,
    object___gear,
    object_document_documentArrow,
    people___businessMale,
    people___groupFemale,
    people___teacherPresent,
} from '@lsg/icons';

export const rulesData = [
    {
        icon: people___groupFemale,
        title: 'Team Size & Composition',
        description: [
            'Teams must have a minimum of three and a maximum of six members.',
            'We encourage teams to have a diverse composition, including engineers, designers and analysts.',
            'Each team member must submit the registration form individually.',
        ],
    },
    {
        icon: object___clock,
        title: 'Work Time',
        description: [
            'Participants are encouraged to brainstorm ideas, concepts, and designs once the challenges have been announced.',
            'However, coding should commence only after the official start of the coding phase on Friday at 12 pm.',
            'Participants are allowed to work on their projects until the submission deadline on Sunday at 12 pm.',
        ],
    },
    {
        icon: interaction___flashOn,
        title: 'Challenges',
        description: [
            'Challenges will be partially published before registration opens, providing an overview.',
            'During registration, teams must choose the specific challenge they wish to tackle',
            'Each team is allowed to submit only one project, addressing a single challenge.',
        ],
    },
    {
        icon: object___gear,
        title: 'Tools & Frameworks',
        description: [
            'The project code must be uploaded to GitHub. A fresh repository should be created no earlier than Friday morning.',
            'Participants are permitted to utilize external tools, frameworks, APIs etc.',
            'However, such tools must either be published under a trial license or be freely usable by all other participants.',
        ],
    },
    {
        icon: object_document_documentArrow,
        title: 'Final Submission',
        description: [
            'The final submission must be sent to the committee by Sunday at 12 pm.',
            'Any major changes, such as new features or significant redesigns, made after the deadline will not be considered. Minor debugging and fixing of small issues are permitted to a limited extent.',
            'The primary focus of the final submission should be the running code.',
        ],
    },
    {
        icon: people___businessMale,
        title: 'Hackathon Committee',
        description: [
            'The local hackathon committee reserves the right to overrule any rule above in order to achieve the best experience for all parties involved.',
        ],
    },
    // {
    //     icon: banking___gem,
    //     title: 'Price',
    //     description:
    //         '[There will be one winning team per challenge per location as well as one grand winner per location cross all challenges. The prices are to be shared equally between team members.]',
    // },
    // {
    //     icon: communication_feedback_agreement,
    //     title: 'Code of Conduct',
    //     description:
    //         '[Everyone should treat all team members, competitors, judges, coaches, volunteers and otherwise involved with respect and courtesy and follow the code of conduct (link here). Persons that violate this rule are at risk of being disqualified and removed from the event.]',
    // },
    // {
    //     icon: people___teacherPresent,
    //     title: 'Presentation',
    //     description:
    //         '[Selected teams may present their results during a 5 minute presentation that shows off their idea, concept and most importantly the created application.]',
    // },
    // {
    //     icon: object_document_checklist,
    //     title: 'Judging Criteria',
    //     description:
    //         '[Teams will be judged on the innovative character of their idea, its technical implementation (in terms of technology used and quality of code), its fit to the challenge and degree of completion of the project.]',
    // },
];
